import { getLanguage } from "i18n";

// R9: in Urdu (RTL) the amount is wrapped in Unicode isolates (LRI ... PDI) so "Rs 1,234"
// never gets reordered inside an Urdu sentence. Western digits + "Rs" as Pakistani apps use.
// Part C (29 Oct 2026): "Rs 3,499" -- thousands separators, decimals only when paisa != 0.
const isolate = (text) => (getLanguage() === "ur" ? `⁦${text}⁩` : text);

/**
 * Display store prices in Pakistani Rupees (PKR). Numeric values are stored as plain numbers.
 * @param {number|string|null|undefined} price
 * @returns {string}
 */
export function formatPrice(price) {
  const n = Number(price);
  if (price === null || price === undefined || price === "" || !Number.isFinite(n)) {
    return isolate("Rs 0");
  }
  const rounded = Math.round(n * 100) / 100;
  const digits = Number.isInteger(rounded) ? 0 : 2;
  return isolate(`Rs ${rounded.toLocaleString("en-PK", { minimumFractionDigits: digits, maximumFractionDigits: digits })}`);
}
